export default __webpack_public_path__ + "static/media/Square.3e98b229.svg";